import { render, staticRenderFns } from "./PaketWisataFotoLainnya.vue?vue&type=template&id=4a3c9b8c"
import script from "./PaketWisataFotoLainnya.vue?vue&type=script&lang=js"
export * from "./PaketWisataFotoLainnya.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports